import Flow from 'types/Flow';
import { isVisibleStep } from 'components/SelfServices/Steps/utils';
import { SelfServiceSteps } from 'modules/selfServices/types/SelfServiceSteps';
import { ConnectionTypeLogin } from 'modules/dealers/types/ContextResponse';

import {
  FINAL_INSTRUCTIONS, SHAREBOX_KEY, KIOSK_LOCATION,
} from 'components/SelfServices/Steps/common';

import { SIGNATURE } from '../../common';
import { MOBILITY_PARKING as COMMON_MOBILITY_PARKING } from '../../onSite';
import COMMON_KIOSK_CHECK_OUT_STEPS, { CommonKioskCheckOutSteps } from '../common';

export type ShareboxI32CheckOutSteps =
  CommonKioskCheckOutSteps
  | SelfServiceSteps.MOBILITY_PARKING
  | SelfServiceSteps.KIOSK_LOCATION
  | SelfServiceSteps.SIGNATURE
  | SelfServiceSteps.SHAREBOX_KEY
  | SelfServiceSteps.FINAL_INSTRUCTIONS;

// Alias 'INDOOR' flow
const SHAREBOX_I32_CHECK_OUT_STEPS: Flow<ShareboxI32CheckOutSteps> = {
  ...COMMON_KIOSK_CHECK_OUT_STEPS,
  MOBILITY_PARKING: {
    ...COMMON_MOBILITY_PARKING,
    next: SIGNATURE.key,
  },
  SIGNATURE: {
    ...SIGNATURE,
    previous: COMMON_MOBILITY_PARKING.key,
    next: SHAREBOX_KEY.key,
  },
  // This one is shown in 'remote' flow, i.e. when the user is using their phone
  KIOSK_LOCATION: {
    ...KIOSK_LOCATION,
    key: SHAREBOX_KEY.key,
    previous: SIGNATURE.key,
    next: FINAL_INSTRUCTIONS.key,
    data: {
      ...KIOSK_LOCATION.data,
      isVisible: (selfService, config) => isVisibleStep(KIOSK_LOCATION, selfService, config)
      && config.connectionTypes?.includes(ConnectionTypeLogin.TOKEN),
    },
  },
  // This one is shown when the user is using the kiosk
  SHAREBOX_KEY: {
    ...SHAREBOX_KEY,
    previous: SIGNATURE.key,
    next: FINAL_INSTRUCTIONS.key,
  },
  FINAL_INSTRUCTIONS: { ...FINAL_INSTRUCTIONS, previous: SHAREBOX_KEY.key },
};

export default SHAREBOX_I32_CHECK_OUT_STEPS;
